import pl from 'vuetify/src/locale/pl.ts'

export default {
  pl,
}
